export default "__VITE_ASSET__DuydsNLu__"